module.exports = __webpack_public_path__ + "static/media/bf.57907e66.svg";